module.exports = __webpack_public_path__ + "static/media/img_checklist.88d41c4b.svg";